import React from 'react';
import {FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {AutoplayRoundsSelectorOption} from './AutoplayRoundsSelectorOption';

type AutoplayRoundsSelectorProps = {
    options: number[];
    value: number | null;
    width: number;
    gapBetweenOptions?: number;
    onChange: (value: number) => void;
    isNotValid?: boolean;
    itemSize: {width: number; height: number;};
};

export class AutoplayRoundsSelector extends React.Component<AutoplayRoundsSelectorProps> {
    protected onSelect(value: number): void {
        this.props.onChange(value);
    }

    protected getOption(option: number): JSX.Element {
        const {value, isNotValid, itemSize} = this.props;

        return <AutoplayRoundsSelectorOption
            isNotValid={isNotValid}
            key={option}
            selected={option === value}
            value={option}
            onToggle={this.onSelect.bind(this)}
            size={itemSize}
            name={`rounds_${option}`}
        />;
    }

    public render(): JSX.Element {
        const {options, width, gapBetweenOptions = 0} = this.props;

        return (
            <FlexBoxComponent containerWidth={width} justifyContent={'center'} alignItems={'center'}>
                <FlexBoxComponent
                    name={'AutoplayRoundsSelector'}
                    wrap={true}
                    direction={'row'}
                    containerWidth={width}
                    gap={gapBetweenOptions}
                >
                    {options.map(this.getOption.bind(this))}
                </FlexBoxComponent>
            </FlexBoxComponent>
        );
    }
}
